import { immerable } from "immer";
import { TranskodeYoutubeChannelDeliveryPolicy } from "./transkode-youtube-channel-delivery";

export class YoutubeChannel {
  [immerable] = true;
  name: string | null = null;
  channelId: string | null = null;
  assetLabels: string[] | null = [];
  description: string | null = null;
  keywords: string[] | null = [];
  notifySubscribers: boolean | null = null;
  ownership: string[] | null = [];
  blockOutsideOwnership: boolean | null = null;
  usagePolicy: TranskodeYoutubeChannelDeliveryPolicy | null = null;
  adBreakTime: number | null = null;
  preRoll: boolean | null = null;
  endRoll: boolean | null = null;
  playlistId: string[] | null = [];
  isMadeForKids: boolean | null = null;

  constructor(init?: Partial<YoutubeChannel>) {
    Object.assign(this, init);
  }
}
